import React from 'react'
import { Controller } from 'react-hook-form'
import DatePicker from 'react-datepicker'
import DateInput from './date-input'

const DateSelect = props => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      defaultValue={moment().format('MM/DD/YYYY')}
      render={({ field }) => (
        <DatePicker className='league-date-select league-control'
          customInput={<DateInput label={props.label} />}
          onChange={date => field.onChange(date.format('MM/DD/YYYY'))}
          selected={moment(new Date(field.value))}
        />
      )}
    />
  )
}

export default DateSelect
